export default __webpack_public_path__ + "static/media/HeroBanner_with_link_mob.86a8b409.jpg";